// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserStatistics_header__dCkGu {
    margin-bottom: 25px;
}

.UserStatistics_title__WcT7O {
    font-size: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/UserStatistics/index.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".header {\n    margin-bottom: 25px;\n}\n\n.title {\n    font-size: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `UserStatistics_header__dCkGu`,
	"title": `UserStatistics_title__WcT7O`
};
export default ___CSS_LOADER_EXPORT___;
